import { Button, Link, Typography } from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';
import useStyles from './useStyles';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import downloadOrganizersExcel from '../../../common/downloadOrganizersExcel';
import translate from '../../../i18n/translate';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../modules/store/hooks';
import OrganizersDataGrid from '../OrganizersDataGrid';
import { userApi } from '../../../modules/services/userService';
import downloadOrganizersShortExcel from '../../../common/downloadOrganizersShortExcel';

const ProfilesScreen = () => {
  const classes = useStyles();
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();
  const { type } = useParams<{ type: string }>();

  const language = useAppSelector((state) => state.auth.language)

  const [organizersType, setOrganizersType] = useState<string>(type || 'all')
  const [count, setCount] = useState<number>(0);

  const organizersTypes = [
    {
      key: 'all',
      title: translate('organizersAllOrganizers')
    },
    {
      key: 'active',
      title: translate('organizersActiveOrganizers')
    },
    {
      key: 'notActive',
      title: translate('organizersNotActiveOrganizers')
    },
  ]

  const handleDownload = () => {
    downloadOrganizersExcel(organizersType, language?.split('-')?.[0])
  }

  const handleDownloadShort = () => {
    downloadOrganizersShortExcel(organizersType, language?.split('-')?.[0])
  }

  const { data: totalCreditsCount, refetch } = userApi.useGetRobotSmsTotalCreditsQuery('');

  useEffect(() => {
    setTimeout(() => {
      refetch();
    }, 60000)
  }, [refetch])

  const organizerId = searchParams.get("organizerId")

  const handleOrganizersTypeChange = (newType: string) => {
    setOrganizersType(newType);

    navigate(`/organizers/${newType}`);
  }

  return(
      <div className={classes.Wrapper}>
        <div className={classes.StatusesList}>
          <Link 
            color="#fc7f03" 
            className={classes.ToMain} 
            mr={10} 
            ml="10px" 
            onClick={() => navigate("/")}
          >
            {translate('commonBackToTheMainPage')}
          </Link>
          {organizersTypes.map((item, index)=>(
            <Link
              key={index}
              style={{
                cursor: "pointer",
                color: "#fc7f03",
                textDecorationColor: "#fc7f03",
                textDecoration: item.key === organizersType ? 'underline' : "none",
                fontSize: "20px",
              }} 
              onClick={() => handleOrganizersTypeChange(item.key)}
            >
              {item.title}
            </Link>
          ))}
          <div/>
          <Typography sx={{ marginInlineStart: '20px' }} fontSize={18} color='#fc7f03'>
            {translate('profilesTotalCreditsCountL')}
            &nbsp;
            <b>
              {totalCreditsCount}
            </b>
          </Typography>
          <Typography sx={{ marginInlineStart: '20px' }} fontSize={18} color='#fc7f03'>
            {translate('organizersTotalCount')}
            &nbsp;
            <b>
              {count}
            </b>
          </Typography>
          <Button 
            sx={{
              color: "black", 
              marginLeft: "20px"
            }} 
            startIcon={<SummarizeIcon sx={{color: "black"}}/>}
            onClick={handleDownload}
          >
            {translate("organizersButtonDownloadExcel")}
          </Button>
          <Button 
            sx={{
              color: "black", 
              marginLeft: "10px"
            }} 
            startIcon={<SummarizeIcon sx={{color: "black"}}/>}
            onClick={handleDownloadShort}
          >
            {translate("organizersButtonDownloadShortExcel")}
          </Button>
        </div>
        <OrganizersDataGrid type={organizersType} count={count} setCount={setCount} organizerId={organizerId ? Number(organizerId) : undefined} />
      </div>
  )
}

export default ProfilesScreen;